import { useRef, useEffect, RefObject } from "react";

export default function useEventListeners(eventNames: string[], handler: Function, elementRef?: RefObject<any>) {
  const handlerRef = useRef<any>(null);
  handlerRef.current = handler;

  useEffect(() => {
    const element = elementRef?.current ?? window;

    if (!element?.addEventListener || !Array.isArray(eventNames) || eventNames.length === 0)
      return;

    const eventListener = (...params: any[]) => handlerRef.current(...params);
    eventNames.forEach(name => element.addEventListener(name, eventListener));
    return () => eventNames.forEach(name => element.removeEventListener(name, eventListener));
  }, [eventNames, elementRef]);
}
